import type { PatSnapCommonResponseData } from '@patsnap/tahiti-core/common/ps-http';
import {
    PsHttpService,
} from '@patsnap/tahiti-core/common/ps-http';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';

import type { InputExample } from '@/domains/home/apis/home-api';

export interface AgentCardResponse {
    cards: AgentCard[]
}

export interface AgentCard {
    function_id: string;
    name?: string;
    goal?: string;
    icon_url?: string;
    type: 'A' | 'P';
    agent_id?: number;
    is_free?: boolean;
}

export interface AgentCategory {
    category: string;
    agents: AgentCard[];
}

export interface HomeMaterialApi {
    getRecommendCases(): Promise<InputExample[]>;
    getProducts(): Promise<AgentCard[]>;
}

export const HomeMaterialApi = Symbol('HomeMaterialApi');

@injectable()
export class HomeMaterialApiImpl extends PsHttpService implements HomeMaterialApi {
    get options() {
        return {
            baseURL: `${import.meta.env.VITE_EUREKA_SERVICE_URI}`,
            headers: {
                'X-API-Version': '1.0',
            },
        };
    }

    getProducts() {
        return this.get<PatSnapCommonResponseData<AgentCard>>({
            url: '/eureka/material-home-page/material-cards',
            method: 'GET',
        }).then((res) => {
            return (res?.data as unknown as AgentCardResponse).cards
        }).catch((err) => {
            console.error('get Material Products error', err);
            return [] as unknown as AgentCard[];
        });
    }

    getRecommendCases() {
        return this.get<PatSnapCommonResponseData<InputExample[]>>({
            url: '/eureka/material-home-page/material-recommend-cases',
            method: 'GET',
        }).then((res) => {
            return res?.data as unknown as InputExample[];
        });
    }
}
